import api from '@/api'
import {axios} from '@/utils/request'
import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

import app from './modules/app'
import fields from './modules/field'
import i18n from './modules/i18n'
import menuParams from './modules/menu-params'
import permission from './modules/permission'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    i18n,
    permission,
    fields,
    menuParams
  },
  state: {
    itemExchangeList:[]
},
  mutations: {
    itemExchangeMutation(state,data){
      state.itemExchangeList = data
    }
  },
  actions: {
     getItemExchangeListAction(store){
       axios({
         url: api.findAll,
         method: 'post',
         headers:{'type':'itemExchangeFactory'},
         data: {}
       }).then(
         data => {
           console.log('res=>', data)
           store.commit('itemExchangeMutation',data)
         })
     }
  },
  getters
})
